

import Title from './Child/Title';
import VideoPlayer from './Child/VideoPlayer';
import Description from './Child/Description';
import VideosInfo from './Child/VideosInfo';

const Default = ({ attributes, videos }) => {
    const { player, desc } = attributes;

    return videos.map((videoItem, index) => {
        const { id, snippet, statistics } = videoItem;
        const { title, description } = snippet;

        return <div className='singleItem' key={index}>
            <VideoPlayer videoId={id} title={title} player={player} />
            <Title title={title} videoId={id} attributes={attributes} />
            {desc?.show && <Description description={description} desc={desc} />}
            <VideosInfo snippet={snippet} statistics={statistics} attributes={attributes} />

        </div>

    });

}
export default Default;